<div class="px-8 py-0">
  <h1 class="font-medium flex flex-col mt-4 mx-0 mb-0 pt-1 pr-4 pb-0 pl-0 text-(length:--font-size-headline-xl)">
    Registr zastupování
  </h1>
  <p class="max-w-200 wrap-break-word">
    Informační systém oprávnění k zastupování provozovaný Digitální a informační agenturou dle § 52a zákona č. 111/2009
    Sb. o Základních registrech, slouží k zápisu a vedení údajů o oprávnění k zastupování, údajů o typech oprávnění k
    zastupování a údajů o certifikátech pro uznávané elektronické podpisy a uznávané elektronické pečetě v rozsahu údajů
    pro ověřování těchto podpisů a pečetí.
  </p>

  <reza-warning-text-field></reza-warning-text-field>

  <div class="flex flex-col items-start mt-12 mr-8" data-cy="link-seznam-sablon">
    <a
      class="flex items-center text-(length:--font-size-body-xl)"
      routerLink="/seznam-sablon"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
      ><i class="pi pi-info-circle text-(length:--icon-size-3xl) mr-3 ml-0"></i>Katalog typu oprávnění k zastupování<i
        class="pi pi-angle-right text-(length:--icon-size-2xl) ml-1.5"></i
    ></a>
    <p class="max-w-200 wrap-break-word">
      Oprávnění k zastupování jsou sestavována podle schválených typů oprávnění k zastupování (šablon).
    </p>
  </div>

  <div class="flex flex-col items-start mt-12 mr-8" data-cy="link-seznam-skupin-sablon">
    <a
      class="flex items-center text-(length:--font-size-body-xl)"
      routerLink="/katalog-skupin-sablon"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
      ><i class="pi pi-info-circle text-(length:--icon-size-3xl) mr-3 ml-0"></i>Katalog skupin typu oprávnění k
      zastupování<i class="pi pi-angle-right text-(length:--icon-size-2xl) ml-1.5"></i
    ></a>
    <p class="max-w-200 wrap-break-word">
      Skupiny typů oprávnění k zastupování (šablon) obsahují typy oprávnění k zastupování (šablony) dle kterých je možné
      sestavit oprávnění k zastupování pro pověřenou osobu.
    </p>
  </div>

  <div class="flex flex-col items-start mt-12 mr-8" data-cy="link-prirucka">
    <a
      class="flex items-center text-(length:--font-size-body-xl)"
      routerLink="/dms"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
      ><i class="pi pi-receipt text-(length:--icon-size-3xl) mr-3"></i>Dokumentace<i
        class="pi pi-angle-right text-(length:--icon-size-2xl) ml-1.5"></i
    ></a>
    <p class="max-w-200 wrap-break-word">Dokumentace k AIS REZA a uživatelská příručka.</p>
  </div>
</div>
